import { Controller } from '@libs/ui/form'
import { usePlanningFormTranslation } from '@libs/utils/translations'
import { formatErrors } from '@spa/components/FormFields/helpers'
import { useMemoSelector } from '@spa/redux/hooks'
import type { FC } from 'react'
import { useEffect } from 'react'
import { useFormContext } from 'react-hook-form'
import { getCurrentAccountId } from 'snap-redux/modules/accounts/selectors'
import { getLocationsByAccountId } from 'snap-redux/modules/locations/selectors'
import { getTeamsByLocationId } from 'snap-redux/modules/teams/selectors'

import type { NewUserFormType } from '../hooks/useNewUserForm'

export const FieldLocationTeamCreateUser: FC = () => {
  const { t, tCommon } = usePlanningFormTranslation()

  const {
    control,
    formState: { errors },
    watch,
    setValue
  } = useFormContext<NewUserFormType>()

  const selectedLocationId = watch('location_id')
  const accountId = useMemoSelector(getCurrentAccountId)

  const locations = useMemoSelector(state =>
    getLocationsByAccountId(state, accountId)
  )
  const teamsByLocation = useMemoSelector(state =>
    getTeamsByLocationId(state, selectedLocationId)
  )

  useEffect(() => {
    setValue('team_id', teamsByLocation?.first()?.id)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [control, teamsByLocation])

  const isAtLeastTwoTeams = teamsByLocation && teamsByLocation.size >= 2

  if (!locations) {
    return null
  }

  const locationsOptions = locations
    .valueSeq()
    .toJS()
    .map(({ id, name }) => ({
      value: id,
      label: name
    }))

  return (
    <>
      <Controller.Select
        control={control}
        options={locationsOptions}
        dropdownPosition='top-start'
        errorMessage={formatErrors({
          inputName: 'location_id',
          errors,
          t
        })}
        required
        fillWidth
        searchable
        searchAdapter='fuzzyIncludingGroup'
        label={t('membershipCreation.location.label')}
        name='location_id'
        clearable
      />

      {isAtLeastTwoTeams && (
        <Controller.Select
          control={control}
          clearable
          name='team_id'
          options={teamsByLocation
            .valueSeq()
            .toJS()
            .map(({ id, name }) => ({
              value: id,
              label: name
            }))}
          required
          label={tCommon('global.team')}
          searchable
          searchAdapter='fuzzyIncludingGroup'
        />
      )}
    </>
  )
}
